export interface Platform {
  IS_IOS: boolean;
  IS_ANDROID_OS: boolean;
  IS_DESKTOP: boolean;
  // IS_WINDOWS: boolean;// TODO: Implement this
  // IS_MAC: boolean;
  // IS_OTHER: boolean;
}

export interface Device {
  IS_IPHONE: boolean;
  // IS_IPAD: boolean; // TODO: Implement this
  // IS_ANDROID: boolean;
}

export interface Browser {
  IS_CHROME: boolean;
  // IS_FIREFOX: boolean; // TODO: Implement this
  // IS_SAFARI: boolean;
  // IS_EDGE: boolean;
  // IS_OPERA: boolean;
  // IS_OTHER: boolean;
}

/**
 * DeviceInfoCustomFlags are custom complex flags that are constructed out of other DeviceInfoInterface flags.
 * These flags are used to detect a browser/OS/version combinations.
 */
export interface DeviceInfoCustomFlags {
  IS_IOS_CHROME?: boolean;
}

export interface DeviceInfoInterface {
  device: Device;
  platform: Platform;
  browser: Browser;
  customFlags: DeviceInfoCustomFlags;
}

export const DeviceInfoDefaults: DeviceInfoInterface = {
  device: {
    IS_IPHONE: false,
    // IS_IPAD: false, // TODO: Implement this
    // IS_ANDROID: false,
  },
  platform: {
    IS_IOS: false,
    IS_ANDROID_OS: false,
    IS_DESKTOP: false,
    // IS_WINDOWS: false, // TODO: Implement this
    // IS_MAC: false,
    // IS_OTHER: false,
  },
  browser: {
    IS_CHROME: false,
    // IS_FIREFOX: false, // TODO: Implement this
    // IS_SAFARI: false,
    // IS_EDGE: false,
    // IS_OPERA: false,
    // IS_OTHER: false,
  },
  customFlags: {},
};
